import React, { useEffect, useState } from "react";

import "./PublicProductList.css";
import { BASE_URL } from "../config";
const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sizeFilter, setSizeFilter] = useState("");
  const [skuFilter, setSkuFilter] = useState("");

  // Placeholder (data URI) na wypadek braku lub błędu ładowania obrazka
  const PLACEHOLDER_SRC =
    "data:image/svg+xml;utf8,"
    + encodeURIComponent(
      "<svg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'>"
        + "<rect width='100%' height='100%' fill='#f0f0f0'/>"
        + "<text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#999' font-family='Arial, sans-serif' font-size='14'>Brak zdjęcia</text>"
      + "</svg>"
    );

  // Buduje poprawny URL obrazka w oparciu o BASE_URL i różne formaty wartości w polu image
  const getImageSrc = (image) => {
    if (!image) return PLACEHOLDER_SRC;
    if (typeof image !== "string") return PLACEHOLDER_SRC;
    const trimmed = image.trim();
    if (!trimmed) return PLACEHOLDER_SRC;
    // Absolutny URL
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    // Ścieżka zaczynająca się od '/'
    if (trimmed.startsWith("/")) return `${BASE_URL}${trimmed}`;
    // Sama nazwa pliku (ścieżka względna z backendu)
    return `${BASE_URL}/static/media/${trimmed}`;
  };

  // 🔹 Pobieranie produktów z API
  useEffect(() => {
    fetch(`${BASE_URL}/api/public/products`)
      .then((res) => res.json())
      .then((data) => setProducts(data))
      .catch((err) => console.error("Błąd przy pobieraniu danych:", err));
  }, []);

  // 🔹 Lista unikalnych rozmiarów i SKU do filtrów
  const uniqueSizes = [...new Set(products.map((p) => p.size))];
  const uniqueSkus = [...new Set(products.map((p) => p.sku).filter(Boolean))];

  // 🔹 Filtracja produktów
  const filteredProducts = products.filter((product) => {
    const matchesSearch = product.name
      .toLowerCase()
      .includes(searchTerm.toLowerCase());
    const matchesSize = sizeFilter ? product.size === sizeFilter : true;
    const matchesSku = skuFilter ? product.sku === skuFilter : true;
    return matchesSearch && matchesSize && matchesSku;
  });

  return (
    <div className="product-page">
      <h1 className="title">Lista Produktów</h1>

      {/* FILTRY */}
      <div className="filters">
        <input
          type="text"
          placeholder="Szukaj po nazwie..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />

        <select
          value={sizeFilter}
          onChange={(e) => setSizeFilter(e.target.value)}
        >
          <option value="">Wszystkie rozmiary</option>
          {uniqueSizes.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>

        <select
          value={skuFilter}
          onChange={(e) => setSkuFilter(e.target.value)}
        >
          <option value="">Wszystkie SKU</option>
          {uniqueSkus.map((sku) => (
            <option key={sku} value={sku}>
              {sku}
            </option>
          ))}
        </select>

        {(sizeFilter || skuFilter || searchTerm) && (
          <button
            className="clear-btn"
            onClick={() => {
              setSearchTerm("");
              setSizeFilter("");
              setSkuFilter("");
            }}
          >
            Wyczyść filtry
          </button>
        )}
      </div>

      {/* LISTA PRODUKTÓW */}
      <div className="product-grid">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product) => (
            <div key={product.id} className="product-card">
              <div className="img-wrapper">
                <img
                  src={getImageSrc(product.image)}
                  alt={product.name || "Produkt"}
                  onError={(e) => {
                    // Zapobiega zapętleniu onError
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = PLACEHOLDER_SRC;
                  }}
                />
              </div>
              <div className="product-info">
                <h3>{product.name}</h3>
                <p>
                  Rozmiar: <strong>{product.size}</strong>
                </p>
                <p>SKU: {product.sku || "—"}</p>
              </div>
            </div>
          ))
        ) : (
          <p className="no-results">Brak produktów spełniających kryteria.</p>
        )}
      </div>
    </div>
  );
};

export default ProductList;
